// import {Grid} from "@mui/material";
import React from "react";
import Grid from "@mui/material/Unstable_Grid2";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  TextField,
  Button,
  Box,
  Link,
  Typography,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import UGTable from "../../../../Supporting files/UGTable/UGTable";
import SelectDropdown from "../../../../Supporting files/SelectDropdown/SelectDropdown";
import SearchDropdown from "../../../../Supporting files/SearchDropdown/SearchDropdown";
import SlidingPanel from "react-sliding-side-panel";
interface Props {
  attrName: any;
  open_status: boolean;
  value_update: Function;
}

const Request: React.FC<Props> = ({ open_status, attrName, value_update }) => {
  const [addPolicyStatus, setAddPolicyStatus] = React.useState(false);
  const [endorsementStatus, setEndorsementStatus] = React.useState(false);
  const [editEndorsementStatus, setEditEndorsementStatus] =
    React.useState(false);

  const [requestType, setRequestType] = React.useState("");
  const [policy, setPolicy] = React.useState("");
  const [planName, setPlanName] = React.useState("");
  const [type, setType] = React.useState("");
  const [status, setStatus] = React.useState("");
  const [insurer, setInsurer] = React.useState("");
  const [newsValue, setNewsValue] = React.useState("");
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    // if (attrName === "expiry") {
    //   setExpiryStatus(event.target.value as string);
    // }
  };
  let requestType_data = [
    { key: "Endorsement", value: "Endorsement" },
    { key: "Claim", value: "Claim" },
  ];
  let policy_data = [
    { key: "Health", value: "Health" },
    { key: "Car", value: "Car" },
    { key: "Bike", value: "Bike" },
    { key: "Term", value: "Term" },
    { key: "Investment", value: "Investment" },
    { key: "Travel", value: "Travel" },
  ];
  let planName_data = [
    { key: "Group Health Insurance", value: "Group Health Insurance" },
    { key: "Group Term Insurance", value: "Group Term Insurance" },
    { key: "Group Personal Accident", value: "Group Personal Accident" },
    { key: "Group Critical Illness", value: "Group Critical Illness" },
    { key: "Group Travel Insurance", value: "Group Travel Insurance" },
    { key: "Voluntary Plans", value: "Voluntary Plans" },
  ];
  let type_data = [
    { key: "Health", value: "Health" },
    { key: "Car", value: "Car" },
    { key: "Bike", value: "Bike" },
    { key: "Term", value: "Term" },
    { key: "Investment", value: "Investment" },
    { key: "Travel", value: "Travel" },
  ];
  let status_data = [
    { key: "InProgress", value: "InProgress" },
    { key: "Active", value: "Active" },
    { key: "Rejected", value: "Rejected" },
  ];
  let insurer_data = [
    { label: "Reliance", value: "Reliance" },
    { label: "Digit", value: "Digit" },
  ];

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "endorsement_id",
      headerName: "Request ID",
      flex: 2,
      minWidth: 150,
      check_status: true,
    },
    {
      field: "request_type",
      headerName: "Request Type",
      flex: 2,
      minWidth: 150,
      check_status: true,
    },
    {
      field: "policy",
      headerName: "Policy",
      flex: 1,
      minWidth: 150,
      check_status: true,
    },
    {
      field: "plan_name",
      headerName: "Plan Name",
      flex: 2,
      minWidth: 150,
      check_status: true,
    },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      minWidth: 100,
      check_status: true,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 2,
      minWidth: 100,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return <span className={row.status}>{row.status}</span>;
      },
    },
    {
      field: "insurer",
      headerName: "Insurer",
      flex: 2,
      minWidth: 100,
      check_status: true,
    },
  ]);
  const rows = [
    {
      id: 0,
      endorsement_id: "EV2342",
      request_type: "Endorsement",
      policy: "Health",
      type: "Member Edition",
      status: "Inprogress",
      insurer: "Reliance",
      plan_name: "Group Health Insurance",
    },
    {
      id: 1,
      endorsement_id: "EV2342",
      request_type: "Claim",
      policy: "Term",
      type: "Rembersement",
      status: "Active",
      insurer: "Reliance",
      plan_name: "Group Term Insurance",
    },
    {
      id: 2,
      endorsement_id: "EV2342",
      request_type: "Endorsement",
      policy: "Health",
      type: "Member Edition",
      status: "Inprogress",
      insurer: "Reliance",
      plan_name: "Group Health Insurance",
    },
    {
      id: 3,
      endorsement_id: "EV2342",
      request_type: "Endorsement",
      policy: "Term",
      type: "Member Edition",
      status: "Rejected",
      insurer: "Reliance",
      plan_name: "Group Term Insurance",
    },
    {
      id: 4,
      endorsement_id: "EV2342",
      request_type: "Claim",
      policy: "Health",
      type: "Cashless",
      status: "Active",
      insurer: "Reliance",
      plan_name: "Group Health Insurance",
    },
    {
      id: 5,
      endorsement_id: "EV2342",
      request_type: "Endorsement",
      policy: "Health",
      type: "Member Edition",
      status: "Active",
      insurer: "Reliance",
      plan_name: "Group Health Insurance",
    },
    {
      id: 6,
      endorsement_id: "EV2342",
      request_type: "Endorsement",
      policy: "Term",
      type: "Member Edition",
      status: "Inprogress",
      insurer: "Reliance",
      plan_name: "Group Term Insurance",
    },
    {
      id: 7,
      endorsement_id: "EV2342",
      request_type: "Endorsement",
      policy: "Health",
      type: "Member Edition",
      status: "Rejected",
      insurer: "Reliance",
      plan_name: "Group Health Insurance",
    },
    {
      id: 8,
      endorsement_id: "EV2342",
      request_type: "Endorsement",
      policy: "Health",
      type: "Member Edition",
      status: "Inprogress",
      insurer: "Reliance",
      plan_name: "Group Health Insurance",
    },
    {
      id: 9,
      endorsement_id: "EV2342",
      request_type: "Endorsement",
      policy: "Health",
      type: "Member Edition",
      status: "Rejected",
      insurer: "Reliance",
      plan_name: "Pro Health Protect Plan",
    },
  ];

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };

  return (
    <Grid container spacing={3} className="claimAssistant">
      <Modal open={addPolicyStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={3}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setAddPolicyStatus(false);
                }}
              />
              <h5 className="popup-heading">Uploading file</h5>
            </Grid>
          </Grid>
          <Grid container spacing={0}>
            <Grid xs={12} className="mb-5">
              <Link className="md-link" underline="none">
                67%... donot close or switch tab while it’s uploading
              </Link>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn" style={{ textAlign: "center" }}>
              <Button variant="contained" className="submitBtn">
                Upload
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <SlidingPanel
        type={"right"}
        isOpen={endorsementStatus}
        size={75}
        panelClassName="slidingPanel"
        backdropClicked={() => setEndorsementStatus(false)}
      >
        <Box className={open_status == true ? "modalInner show" : "modalInner"}>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={9}>
              <h4 className="mb-0 text-left">Raise New Request</h4>
            </Grid>
            <Grid xs={3}>
              <Link
                className="close-button"
                onClick={() => {
                  setEndorsementStatus(false);
                }}
              />
            </Grid>
          </Grid>

          <div className="scrollable_area">
            <Grid container spacing={3}>
              <Grid xs={12} sx={{ padding: "0px" }}>
                <Typography>
                  <Grid
                    container
                    spacing={3}
                    justifyContent="center"
                    alignItems="center"
                    className="mb-4"
                  >
                    <Grid xs={6}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Request Type"
                        attrName={setRequestType}
                        value={requestType}
                        value_update={updateMasterState}
                        dropdown_data={requestType_data}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Policy"
                        attrName={setPolicy}
                        value={policy}
                        value_update={updateMasterState}
                        dropdown_data={policy_data}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Plan Name"
                        attrName={setPlanName}
                        value={planName}
                        value_update={updateMasterState}
                        dropdown_data={planName_data}
                      />
                    </Grid>

                    <Grid xs={6}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Type"
                        attrName={setType}
                        value={type}
                        value_update={updateMasterState}
                        dropdown_data={type_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <SelectDropdown
                        class_name="inputField"
                        title="Status"
                        attrName={setStatus}
                        value={status}
                        value_update={updateMasterState}
                        dropdown_data={status_data}
                        warn_status={false}
                      />
                    </Grid>
                    <Grid xs={6}>
                      <SearchDropdown
                        class_name="inputField"
                        title="Insurer"
                        attrName={setInsurer}
                        value={insurer}
                        value_update={updateMasterState}
                        data={insurer_data}
                        error_message="Please select insurer"
                        warn_status={false}
                      />
                    </Grid>
                  </Grid>
                </Typography>
              </Grid>
            </Grid>
          </div>

          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={() => {}}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </SlidingPanel>
      {/* <Modal open={editEndorsementStatus} className="modalWrapper">
        <Box className="modalInner xl-width">
          <Grid container spacing={3}>
            <Grid xs={12}>
              <Link
                
                className="close-button"
                onClick={() => {
                  setEditEndorsementStatus(false);
                }}
              />
              <h5 className="popup-heading">Edit Request</h5>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={3}
            justifyContent="center"
            alignItems="center"
            className="mb-4">
            <Grid xs={4} className="inputField">
              <SelectDropdown
                class_name="inputField"
                title="Request Type"
                attrName={setRequestType}
                value={requestType}
                value_update={updateMasterState}
                dropdown_data={requestType_data}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4} className="inputField">
              <SelectDropdown
                class_name="inputField"
                title="Policy"
                attrName={setPolicy}
                value={policy}
                value_update={updateMasterState}
                dropdown_data={policy_data}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4} className="inputField">
              <SelectDropdown
                class_name="inputField"
                title="Plan Name"
                attrName={setPlanName}
                value={planName}
                value_update={updateMasterState}
                dropdown_data={planName_data}
                warn_status={false}
              />
            </Grid>

            <Grid xs={4} className="inputField">
              <SelectDropdown
                class_name="inputField"
                title="Type"
                attrName={setType}
                value={type}
                value_update={updateMasterState}
                dropdown_data={type_data}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4} className="inputField">
              <SelectDropdown
                class_name="inputField"
                title="Status"
                attrName={setStatus}
                value={status}
                value_update={updateMasterState}
                dropdown_data={status_data}
                warn_status={false}
              />
            </Grid>
            <Grid xs={4}>
              <SearchDropdown
                class_name="inputField"
                title="Insurer"
                attrName={setInsurer}
                value={insurer}
                value_update={updateMasterState}
                data={insurer_data}
                error_message="Please select insurer"
                warn_status={false}
              />
            </Grid>
          </Grid>
          <Grid container spacing={0} justifyContent="center">
            <Grid lg={3} className="ctaBtn" style={{ textAlign: "center" }}>
              <Button variant="contained" className="submitBtn">
                Submit
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal> */}
      <Grid xs={6}>
        <h3 className="mb-0">Request</h3>
      </Grid>
      <Grid xs={6} className="text-right">
        <Link
          underline="none"
          className="greenBtn addfile"
          onClick={() => {
            setEndorsementStatus(true);
          }}
        >
          Raise New Request
        </Link>
        <Link
          underline="none"
          className="blueBtn edit"
          onClick={() => {
            setEndorsementStatus(true);
          }}
        >
          Edit Request
        </Link>
      </Grid>
      <Grid xs={12}>
        <UGTable
          header_data={columns}
          data={rows}
          value_update={updateMasterState}
          attrName={"UGTable"}
        />
      </Grid>
    </Grid>
  );
};

export default Request;
